import { atom } from "recoil";
import { ENVIORNMENTS, getCurrentEnviornment } from "utils/constants";

export const userProfileAtom = atom({
  key: "userProfileAtom",
  default: null,
});

export const userEmailAtom = atom({
  key: "userEmailAtom",
  default: "",
});

export const userLoggedId = atom({
  key: "userLoggedId",
  default: null,
});
export const twodDataRecoil = atom({
  key: "twodDataRecoil",
  default: null,
});
export const threedDataRecoil = atom({
  key: "threedDataRecoil",
  default: null,
});

export const highlightsAtom = atom({
  key: "highlightsData",
  default: null,
});
export const launchValuesAtom = atom({
  key: "launchValuesData",
  default: null,
});
export const speedValuesAtom = atom({
  key: "speedValuesAtom",
  default: null,
});
export const displacementsGraphValuesAtom = atom({
  key: "displacementsGraphValuesAtom",
  default: null,
});

export const userDetailPopup = atom({
  key: "showPopup",
  default: false,
});

export const userDetailData = atom({
  key: "userDetailData",
  default: {
    username: null,
    userEmail: null,
    userId: null,
  },
});
export const userDetailData2 = atom({
  key: "userDetailData2",
  default: {
    username: null,
    userEmail: null,
    userId: null,
  },
});

export const userListPagination = atom({
  key: "userListPagination",
  default: {
    current: 1,
    pageSize: 100,
    totalRecords: 0,
  },
});
export const userListPagination2 = atom({
  key: "userListPagination2",
  default: {
    current: 1,
    pageSize: 50,
    totalRecords: 0,
    search: "",
    name: "",
    order: "",
  },
});

export const userListSearch = atom({
  key: "userListSearch",
  default: "",
});
export const baseballLandscape = atom({
  key: "baseballLandscape",
  default: false,
});

export const persistedUserOrStrikerId = atom({
  key: "persistedUserOrStrikerId",
  default: null,
});
export const golfDtlOrFaceon = atom({
  key: "golfDtlOrFaceon",
  default: "faceon",
});
export const golfExpandCriticalImages = atom({
  key: "golfExpandCriticalImages",
  default: false,
});

export const activeEnviornment = atom({
  key: "activeEnviornment",
  default: getCurrentEnviornment() || ENVIORNMENTS.LIVE,
});

export const videoFramesImages = atom({
  key: "videoFramesImages",
  default: [],
});
export const DTLvideoFramesImages = atom({
  key: "DTLvideoFramesImages",
  default: [],
});
export const baseballNewPositions = atom({
  key: "baseballNewPositions",
  default: [],
});
export const baseballNewPositionsApiCall = atom({
  key: "baseballNewPositionsApiCall",
  default: null,
});

export const notesListView = atom({
  key: "notesListView",
  default: true,
});
